import { filterServiceTypeOptions } from '../utils';

export const toServiceTypeId = (option = {}) => String(option?.id ?? option?.value ?? '');

export const toServiceTypeLabel = (option = {}) => (
  option?.label || option?.name || toServiceTypeId(option)
);

export const flattenServiceTypeOptions = (options = []) => (
  options.reduce((acc, option) => {
    const { children, ...rest } = option || {};
    acc.push(rest);
    if (Array.isArray(children) && children.length > 0) {
      acc.push(...flattenServiceTypeOptions(children));
    }
    return acc;
  }, [])
);

export const normalizeServiceTypeOptions = (options = []) => (
  flattenServiceTypeOptions(options).map((option) => ({
    ...option,
    value: toServiceTypeId(option),
    label: toServiceTypeLabel(option),
  }))
);

export const buildServiceTypeNextValue = (selectedId, normalizedOptions = []) => {
  if (!selectedId) {
    return null;
  }
  return normalizedOptions.find((opt) => String(opt.value) === String(selectedId)) || { id: selectedId };
};

export const createFilterCache = (options, inputValue) => {
  const filtered = filterServiceTypeOptions(options, inputValue);
  return {
    inputValue,
    ids: new Set(flattenServiceTypeOptions(filtered).map((opt) => toServiceTypeId(opt))),
  };
};

export const candidateMatchesFilter = (candidate, cache) => {
  if (!cache?.ids) return true;
  const candidateId = toServiceTypeId(candidate?.data || {});
  return cache.ids.has(candidateId);
};
